import { useState, useEffect } from "react";
import instance from "../Interceptor/api_instance";

export function useGetInstance<T>(url: string) {
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<string>("");
    const [data, setData] = useState<T | null>(null);

    const fetchData = async () => {
        setIsLoading(true);
        setError("");

        try {
            const response = await instance.get<T>(url);
            setData(response.data);
        } catch (err) {
            setError(err as  string);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [url])

    return { data, isLoading, error, fetchData };
}